<template>
  <div
    class="ta-lot-condition-reports"
    v-if="lot.lot_public_condition_reports && lot.lot_public_condition_reports.length"
  >
    <h4
      class="text-md font-weight-bolder lot-public-condition-reports-title"
    >
      {{ $t("Lot published condition reports") }}
    </h4>
    <ul
      style="list-style-type: none"
      class="p-0 ta-lot-condition-reports-list"
    >
      <li
        class="ta-lot-condition-reports-list-item"
        v-for="report in lot.lot_public_condition_reports"
        :key="report.uuid"
      >
        <ConditionReport :report="report" />
      </li>
    </ul>
  </div>
</template>

<script>
import {mapState} from "vuex";
import ConditionReport from "@/components/condition-report/ConditionReport.vue";

export default {
  name: 'LotPublishedConditionReports',
  components: {
    ConditionReport,
  },
  computed: {
    ...mapState({
      lot: state => state.lotObject.data
    }),
  },
};
</script>
